import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Modal, Grid } from 'semantic-ui-react';

// Global Types
import { AppState } from 'services/types';

// Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
import { makeSelectQueryStringBooleanValue } from 'workspaces/react-router-selectors';

// Global Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import RoleGate from 'components/RoleGate';
import { ADMIN, MANAGER } from 'components/RoleGate/constants';
import ErrorAlert from 'components/ErrorAlert';
import QueryStringButton from 'components/QueryStringButton';
import SubmitMultipleTimesheetModalButton from './components/SubmitMultipleTimesheetModalButton';

interface ConnectedProps {
    open: boolean;
}

interface DispatchProps {
    updateQueryString: Function;
}

export type Props = ConnectedProps & DispatchProps;

export class SubmitMultipleTimesheetModal extends React.PureComponent<Props> {
    handleClose = (): void => {
        this.props.updateQueryString({
            submitMultipleTimesheetsModal: undefined
        });
    };

    render(): React.ReactElement {
        const { open } = this.props;

        return (
            <RoleGate requiredRoles={[ADMIN, MANAGER]}>
                <Modal
                    open={open}
                    onClose={this.handleClose}
                    size="tiny"
                    centered={false}
                    closeIcon
                >
                    <ErrorBoundary
                        namespace="SubmitMultipleTimesheetModal"
                        FallbackComponent={<ErrorBoundaryAlert />}
                    >
                        <Modal.Header>Submit Selected Timesheets</Modal.Header>
                        <Modal.Content>
                            <ErrorAlert namespace="TIMESHEET_MULTIPLE_SUBMIT" />
                            <Grid centered>
                                <Grid.Column
                                    mobile={16}
                                    tablet={8}
                                    computer={8}
                                >
                                    <QueryStringButton
                                        params={{
                                            submitMultipleTimesheetsModal: undefined
                                        }}
                                        buttonProps={{
                                            type: 'button',
                                            fluid: true,
                                            basic: true,
                                            primary: true
                                        }}
                                    >
                                        Cancel
                                    </QueryStringButton>
                                </Grid.Column>
                                <Grid.Column
                                    mobile={16}
                                    tablet={8}
                                    computer={8}
                                >
                                    <SubmitMultipleTimesheetModalButton />
                                </Grid.Column>
                            </Grid>
                        </Modal.Content>
                    </ErrorBoundary>
                </Modal>
            </RoleGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    open: makeSelectQueryStringBooleanValue('submitMultipleTimesheetsModal')
});

export default connect(
    mapStateToProps,
    { updateQueryString }
)(SubmitMultipleTimesheetModal);
